<template>
  <div>
    <div class="table-toolbar">
      <span>{{ $t('admins.adminsNumber') }} {{ groupsData.total }} </span>
      <div class="table-toolbar__group">
        <TableSearch :data-source="groupsData"></TableSearch>
        <TableLimitSelector :data-source="groupsData"></TableLimitSelector>
      </div>
    </div>
    <Table :columns="notificationsColumns" :data-source="groupsData" @clickRow="() => {}"></Table>
  </div>
</template>

<script>
import i18n from '@/i18n';
import utils from '@/utils/functions.js';
import Table from '@/components/Table/Table.vue';
import TableLimitSelector from '@/components/Table/TableLimitSelector.vue';
import TableSearch from '@/components/Table/TableSearch.vue';
import Column from '@/components/Table/Column';
import TableDatasource from '@/components/Table/TableDatasource.js';
import GroupsService from '@/services/groups.service';
import { mapState } from 'vuex';

export default {
  name: 'AdminNotifications',
  components: {
    Table,
    TableLimitSelector,
    TableSearch
  },
  data() {
    return {
      notificationsColumns: [
        new Column({
          value: 'name',
          label: 'nouns.firstName',
          sortable: true
        }),
        new Column({
          value: 'gameName',
          label: 'nouns.gameName',
          sortable: true
        }),
        new Column({
          value: 'licensesResume.total',
          label: 'nouns.total',
          sortable: true
        }),
        new Column({
          value: 'startDate',
          label: 'nouns.startDate',
          sortable: true,
          valueParser: (startDate) => utils.formatDate(this.userData.lang, startDate)
        }),
        new Column({
          value: 'endDate',
          label: 'nouns.endDate',
          sortable: true,
          valueParser: (endDate) => utils.formatDate(this.userData.lang, endDate)
        }),
        new Column({
          value: 'weeks',
          label: 'nouns.duration',
          sortable: true,
          valueParser: (weeks) => `${weeks / 2} ${i18n.t('nouns.months')}`
        })
      ],
      groupsData: {}
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.profile.profileData
    })
  },
  created() {
    const adminId = this.$route.params.id;
    this.groupsData = new TableDatasource({
      sort: 'name',
      aggregates: 'licensesResume',
      filters: new Map().set('agentIds', adminId),
      async load(props) {
        const response = await GroupsService.fetchGroups(props);
        return response.data;
      }
    });
  }
};
</script>
